<template >
  <div id="app">
    <lottie
      :options="defaultOptions"
      :autoplay="true"
      :loop="false"
      :height="300"
      :width="300"
      v-on:animCreated="handleAnimation"
    />
  </div>
</template>

<style scoped>
.app {
  background: #5351a0;
  width:120%;
  height:120%;
  display:block;
  overflow: hidden;
  transform: translate3d(0,0,0);
  text-align: center;
  opacity: 1;
}
.text-color {
  color: #fff !important;
}
</style>

<script>
// import Lottie from "./lottie.vue";
import Lottie from "vue-lottie";
import * as animationData from "./../assets/mockups/spectrum.json";

export default {
  name: "AnimationEmail",
  components: {
    lottie: Lottie
  },
  data: () => ({
    defaultOptions: { animationData: animationData.default },
  }),
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    },
  }
};
</script>
